export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13700.7e11ff95.jpg";